// extracted by mini-css-extract-plugin
export default {"root":"UoAg0oh","content":"khG3agM","title":"mUorg1r","site":"XKsC6pQ","button":"BspEqrM","button__text":"T0pvciJ"};